import { Component,Input, Output, OnInit, EventEmitter } from '@angular/core';
import { ProfileModel } from 'src/app/models/profile.model';
import { DataService } from 'src/app/services/data/data.service';
import { NavController, AlertController, ToastController } from '@ionic/angular';
import { MathService } from 'src/app/services/math/math.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { TranslateService } from '@ngx-translate/core';
import { UserModel } from 'src/app/models/user.model';

@Component({
  selector: 'reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {

  @Input()
  title:string = this.translateService.instant('account.ChangePassword');

  @Input()
  subtitle:string = this.translateService.instant('account.ChangePasswordSubtitle');;

  @Input()
  email:string;

  @Input() 
  public onPasswordReset = () =>{}


  form: UntypedFormGroup;


  constructor(private dataService:DataService, private navCtrl:NavController, private authService:AuthenticationService, 
    public formBuilder:UntypedFormBuilder, private toastCtrl:ToastController, private translateService:TranslateService) {
    this.form = this.formBuilder.group({
      // email:[{value:this.email,disabled:true},Validators.compose([Validators.maxLength(100), Validators.email,Validators.required])],
      currentPassword:["",Validators.compose([Validators.minLength(8),Validators.maxLength(15), Validators.required])],
      newPassword:["",Validators.compose([Validators.minLength(8),Validators.maxLength(15), Validators.required])]
    }); 
  }

  ngOnInit(){

  }

  async presentToast(message) {
    const toast = await this.toastCtrl.create({
      message: message,
      duration:15000,
      buttons:[{
          side:'end',
          icon:'close-circle-outline',
          role:'cancel',
          handler:()=>{
            console.log('dismiss toast');
            //toast.dismiss();
          }
      }],
      position: 'middle'
    });
    toast.present();
  }

  async reset(formOutput){
    if(!this.form.controls.currentPassword.valid){
      this.presentToast(this.translateService.instant('account.CurrentPassword') + ': ' + this.translateService.instant('account.ProvideAValidPassword'));
    }
    else if(!this.form.controls.newPassword.valid){
      this.presentToast(this.translateService.instant('account.NewPassword') + ': ' + this.translateService.instant('account.ProvideAValidPassword'));
    }
    else {
      console.log('reset password');
      this.authService.reauthenticate(formOutput.currentPassword).then(result=>{
        this.authService.changePassword(formOutput.newPassword).then(result => {
          this.onPasswordReset();
        })
        .catch(error =>{
          this.presentToast(this.translateService.instant('errors.ErrorEncountered')+ error);
        })
      })
      .catch(error => {
        this.presentToast(this.translateService.instant('errors.InvalidPassword'));
      })
      this.presentToast(this.translateService.instant('account.PasswordReset'));

    }
  }
}
